import {
  GET_ORDER_DETAIL_LIST_RESPONSE,
  GET_ORDER_DETAIL_WITH_LINES_BY_ORDER_ID_RESPONSE,
  SET_ORDER_STATUS_RESPONSE,
} from "./actionTypes";

import produce from "immer";

export const initialState = {
  orderDetailApiResponse: null,
  orderDetailData: [],
  orderDetailRecord: null,
};

const OrderDetail = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_ORDER_DETAIL_LIST_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.orderDetailData = response.responseData;
        } else {
          draft.orderDetailData = [];
        }
        break;

      case GET_ORDER_DETAIL_WITH_LINES_BY_ORDER_ID_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.orderDetailRecord = response.responseData;
        }
        break;

      case SET_ORDER_STATUS_RESPONSE:
        draft.orderDetailApiResponse = action.payload.apiResponse;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default OrderDetail;
